import React, { useEffect } from "react";
import Site from "./site";
import Article from "./article";
import Faq from "./faq";
import Unmatched from "./unmatched";
import { useSubscription } from "../../../context/subscriptionprovider";
import AccessRestrictedOverlay from "../../../components/restrictoverlay";

const MainContent = ({ active }) => {
  const { isRestricted, activePlan, limitedPermission } = useSubscription();

  const isAccessRestricted =
    isRestricted ||
    !limitedPermission ||
    limitedPermission.custom_dataset_training === false;

  useEffect(() => {
    console.log("isRestricted", isRestricted);
    console.log("activePlan", activePlan);
    console.log("limitedPermission", limitedPermission);
  }, [isRestricted, activePlan, limitedPermission]);

  let content;

  switch (active) {
    case 1:
      content = <Site />;
      break;
    case 2:
      content = <Article />;
      break;
    case 3:
      content = <Faq />;
      break;
    default:
      content = <Unmatched />;
  }

  const shouldRestrict =
    isAccessRestricted && (active === 2 || active === 3 || active === 4);

  return (
    <div className="flex-1 h-auto  bg-white  m-5 rounded-[16px] relative">
      {shouldRestrict ? (
        <AccessRestrictedOverlay content="Unlock personalized training and datasets. Upgrade your subscription to start training your AI assistant today." />
      ) : (
        content
      )}
    </div>
  );
};

export default MainContent;
